"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
exports.viewerPropTypes = {
    translationsUrl: PropTypes.string.isRequired,
    viewerUrl: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    bannerPosition: PropTypes.string.isRequired,
    brotherBannersLocations: PropTypes.arrayOf(PropTypes.string),
    metasiteGuid: PropTypes.string,
    metaSiteId: PropTypes.string,
    dealerOptions: PropTypes.object,
    onView: PropTypes.func,
    onDisplay: PropTypes.func,
    onClick: PropTypes.func,
    onError: PropTypes.func,
    banners: PropTypes.object,
    debug: PropTypes.bool,
};
exports.viewerDefaultProps = {
    debug: false,
    isLightbox: false,
};
//# sourceMappingURL=index.js.map